import { useTRPC } from "@/trpc/client";
import { useQuery } from "@tanstack/react-query";

export function useIntelligenceScope(businessId: string | undefined) {
  const trpc = useTRPC();
  return useQuery(
    trpc.intelligence.getMyScope.queryOptions(
      { businessId: businessId ?? "" },
      { enabled: Boolean(businessId), staleTime: 60_000 },
    ),
  );
}
